/**
 * TanStack Router setup.
 *
 * The Vite plugin generates `src/routeTree.gen.ts` from the files under
 * `src/routes/`. This module imports that generated tree and exports a
 * configured router instance for `<RouterProvider />`.
 */

import { createRouter } from '@tanstack/react-router'

import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
